import { map, mergeMap } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';

@Injectable()
export class VocabularySharedFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">

  currentSelectedPage$ = this.store.select(FlatStates.PageEntityState.currentSelectedPage$);
  currentSelectedVocabularyGroups$ = this.store.select(FlatStates.VocabularyGroupEntityState.currentSelectedVocabularyGroups$);
  currentSelectedVocabularyWord$ = this.store.select(FlatStates.VocabularyWordEntityState.currentSelectedVocabularyWord$);

  //</editor-fold>

  //<editor-fold desc="Lazy Selectors">

  vocabularyGroupByIds$ = (id: any) => this.store.select(FlatStates.VocabularyGroupEntityState.entitiesByIds$).pipe(map(filterFn => filterFn(id as unknown as string[])));
  vocabularyWordByIds$ = (id: any) => this.store.select(FlatStates.VocabularyWordEntityState.entitiesByIds$).pipe(map(filterFn => filterFn(id as unknown as string[])));

  //</editor-fold>

  //<editor-fold desc="Requests">

  requestAddVocabularyGroup(id: string,
                            vocabularyGroup: FlatModels.VocabularyGroupEntityModels.VocabularyGroup) {
    return this.store.dispatch(new FlatActions.VocabularyGroupEntityActions.AddEntity(vocabularyGroup)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.PageEntityActions.AddVocabularyGroup(id, vocabularyGroup))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.vocabulary_group_add',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
    );
  }

  requestUpdateVocabularyGroup(vocabularyGroup: FlatModels.VocabularyGroupEntityModels.VocabularyGroup) {
    return this.store.dispatch(new FlatActions.VocabularyGroupEntityActions.UpdateEntity(vocabularyGroup)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.vocabulary_group_update',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
    );
  }

  requestRemoveVocabularyGroup(id: string,
                               vocabularyGroup: FlatModels.VocabularyGroupEntityModels.VocabularyGroup) {
    return this.store.dispatch(new FlatActions.PageEntityActions.RemoveVocabularyGroup(id, vocabularyGroup)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.VocabularyGroupEntityActions.RemoveEntity(vocabularyGroup))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.vocabulary_group_remove',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
    );
  }

  requestAddVocabularyWord(id: string,
                           vocabularyWord: FlatModels.VocabularyWordEntityModels.VocabularyWord) {
    return this.store.dispatch(new FlatActions.VocabularyWordEntityActions.AddEntity(vocabularyWord)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.VocabularyGroupEntityActions.AddVocabularyWord(id, vocabularyWord))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.vocabulary_word_add',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
    );
  }

  requestUpdateVocabularyWord(vocabularyWord: FlatModels.VocabularyWordEntityModels.VocabularyWord) {
    return this.store.dispatch(new FlatActions.VocabularyWordEntityActions.UpdateEntity(vocabularyWord)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.vocabulary_word_update',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
    );
  }

  requestRemoveVocabularyWord(id: string,
                              vocabularyWord: FlatModels.VocabularyWordEntityModels.VocabularyWord) {
    return this.store.dispatch(new FlatActions.VocabularyGroupEntityActions.RemoveVocabularyWord(id, vocabularyWord)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.VocabularyWordEntityActions.RemoveEntity(vocabularyWord))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.vocabulary_word_remove',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
    );
  }

  //</editor-fold>

}
